import * as React from 'react';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import {Link} from "react-router";
import {stringAvatar, stringToColor} from "../../utils/color";
import MdiIcon from "../../share/components/mdi/MdiIcon.tsx";
import { mdiAccountMultiple } from "@mdi/js";
import {Session} from "../../app/slices/sessionSlice";
import Divider from '@mui/material/Divider';
import { t } from "@lingui/core/macro";

export function secondaryList(session: Session | undefined) {
    return [
        ...(session?.hasPermission('', 'applications/auth/entities/MembersGroups/list/view') ?
            [{
                path: '/dashboard/members-groups',
                name: 'MembersGroups',
                label: t`Members Groups`,
            }] : []),
        
        
        
        
        
        
        
        ...(session?.hasPermission('', 'applications/auth/entities/Users/list/view') ?
            [{
                path: '/dashboard/users',
                name: 'Users',
                label: t`Users`,
            }] : []),
        
        
        
        
        
        
        
        ...(session?.hasPermission('', 'applications/auth/entities/Roles/list/view') ?
            [{
                path: '/dashboard/roles',
                name: 'Roles',
                label: t`Roles`,
            }] : []),
        
        
        
        
        
        
        
        ...(session?.hasPermission('', 'applications/auth/entities/ScopeGroups/list/view') ?
            [{
                path: '/dashboard/scope-groups',
                name: 'ScopeGroups',
                label: t`Scope Groups`,
            }] : []),
        
        
        
        
        
        
        
        
    ]
}

export function secondaryListItems(open: boolean, session: Session | undefined, handleClick: (packageName: string) => void) {
    
    const list = secondaryList(session)
    
    if (list.length === 0) {
        return undefined    
    }
    
    return (
        <React.Fragment>
            <Divider sx={ {my: 1} }/>
            <ListItemButton
                onClick={() => handleClick('auth')}
                data-testid="auth"
            >
                <ListItemIcon>
                    <MdiIcon d={ mdiAccountMultiple } htmlColor="grey" />
                </ListItemIcon>
                <ListItemText primary={t`Auth`}/>
                {open ? <ExpandLess/> : <ExpandMore/>}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    { list.map(item =>
                        <ListItemButton
                            key={item.path}
                            component={Link}
                            to={item.path}
                            data-testid={item.name}
                            aria-label={item.name}
                        >
                            <ListItemIcon>
                                <Avatar {...stringAvatar(item.label)}/>
                            </ListItemIcon>
                            <ListItemText primary={item.label}/>
                        </ListItemButton>)}
                </List>
            </Collapse>
        </React.Fragment>
    );
}
